<template>
  <header class="header">
    <div class="container d-flex">
      <div class="logo-container">
        <router-link to="/" class="logo" active-class="active-logo" @click="refreshIfActive('/')">
          <span class="logo-text" :class="{ 'active-logo-text': $route.path === '/' }">Sogdo</span>
        </router-link>
      </div>

      <nav class="main-nav" :class="{ 'mobile-menu-visible': isMenuOpen && isMobile }">
        <!-- Mobile Menu Toggle Button -->
        <div v-if="isMobile" class="mobile-nav-toggler" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
          <i class="icon-bar"></i>
          <i class="icon-bar"></i>
          <i class="icon-bar"></i>
        </div>

        <!-- Mobile Menu -->
        <div v-if="isMobile" class="mobile-menu">
          <div class="menu-backdrop" @click="closeMenu"></div>
          <div class="close-btn" @click="closeMenu">
            <i class="icon-fa-times"></i>
          </div>
          
          <nav class="menu-box">
            <div class="nav-logo">
              <router-link to="/" @click="closeMenu">
                <span class="logo-text">Sogdo</span>
              </router-link>
            </div>
            <div class="menu-outer">
              <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                <ul class="navigation clearfix home-menu">
                  <li 
                    v-for="(item, index) in navigationItems" 
                    :key="index"
                    class="nav-item"
                    :class="{ 'dropdown': item.type === 'dropdown' }"
                    @click.stop="item.type === 'dropdown' ? toggleDropdown(item.name.toLowerCase()) : null"
                  >
                    <!-- Regular Link -->
                    <router-link 
                      v-if="item.type === 'link'" 
                      :to="item.path" 
                      @click="closeMenu"
                      :class="{ 'router-link-active': $route.path === item.path }"
                    >
                      {{ item.name }}
                    </router-link>
                    
                    <!-- Dropdown -->
                    <template v-else-if="item.type === 'dropdown'">
                      <a href="#" @click.prevent.stop>{{ item.name }}</a>
                      <div class="dropdown-btn" :class="{ 'open': openDropdown === item.name.toLowerCase() }">
                      <span class="icon-07"></span>
                    </div>
                      <ul class="dropdown-menu" :class="{ 'show': openDropdown === item.name.toLowerCase() }">
                        <li 
                          v-for="(child, childIndex) in item.children" 
                          :key="childIndex"
                          class="dropdown-submenu flex-column"
                          :class="{ 'dropdown': child.type === 'dropdown' }"
                          @click.stop="child.type === 'dropdown' ? toggleDropdown(child.name.toLowerCase()) : null"
                        >
                          <!-- Child Link -->
                          <router-link 
                            v-if="child.type === 'link'" 
                            :to="child.path" 
                            @click="closeMenu"
                            :class="{ 'router-link-active': $route.path === child.path }"
                          >
                            {{ child.name }}
                          </router-link>
                          
                          <!-- Child Dropdown -->
                          <template v-else-if="child.type === 'dropdown'">
                            <a href="#" @click.prevent.stop>{{ child.name }}</a>
                            <ul class="nested-dropdown d-block mx-0 border-0" :class="{ 'show': openDropdown === child.name.toLowerCase() }">
                              <li 
                                v-for="(grandChild, grandChildIndex) in child.children" 
                                :key="grandChildIndex"
                                class="dropdown-submenu"
                                :class="{ 'dropdown': grandChild.type === 'dropdown' }"
                                @click.stop="grandChild.type === 'dropdown' ? toggleDropdown(grandChild.name.toLowerCase()) : null"
                              >
                                <!-- Grand Child Link -->
                                <router-link 
                                  v-if="grandChild.type === 'link'" 
                                  :to="grandChild.path" 
                                  @click="closeMenu"
                                  :class="{ 'router-link-active': $route.path === grandChild.path }"
                                >
                                  {{ grandChild.name }}
                                </router-link>
                                
                                <!-- Grand Child Dropdown -->
                                <template v-else-if="grandChild.type === 'dropdown'">
                                  <a href="#" @click.prevent.stop>
                                    {{ grandChild.name }}
                                    <!-- <span class="dropdown-btn" style="top: 27px!important;">
                                      <span class="icon-07"></span>
                                    </span> -->
                                  </a>
                                  <ul 
                                    class="nested-dropdown level-2 flex-column" 
                                    style="display:flex!important;" 
                                    :class="{ 'show': openDropdown === grandChild.name.toLowerCase() }"
                                  >
                                    <li 
                                      v-for="(greatGrandChild, greatGrandChildIndex) in grandChild.children" 
                                      :key="greatGrandChildIndex"
                                    >
                                      <router-link 
                                        :to="greatGrandChild.path" 
                                        @click="closeMenu"
                                        :class="{ 'router-link-active': $route.path === greatGrandChild.path }"
                                      >
                                        {{ greatGrandChild.name }}
                                      </router-link>
                                    </li>
                              </ul>
                                </template>
                            </li>
                          </ul>
                          </template>
                        </li>
                    </ul>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
            <div class="contact-info">
              <h4>Contact Info</h4>
              <ul class="d-block">
                <li>Chicago 12, Melborne City, USA</li>
                <li><a href="tel:+1234567890">+1 (234) 567-8900</a></li>
                <li><a href="mailto:info@example.com">info@example.com</a></li>
              </ul>
            </div>
          </nav>
        </div>

        <!-- Desktop Navigation -->
        <ul v-if="!isMobile" class="nav-links desktop-nav">
          <li 
            v-for="(item, index) in navigationItems" 
            :key="index"
            class="nav-item"
            :class="{ 'dropdown': item.type === 'dropdown' }"
          >
            <!-- Regular Link -->
            <router-link 
              v-if="item.type === 'link'" 
              :to="item.path" 
              class="nav-link" 
              @click="refreshIfActive(item.path)"
              :class="{ 'router-link-active': $route.path === item.path }"
            >
              {{ item.name }}
            </router-link>
            
            <!-- Dropdown -->
            <template v-else-if="item.type === 'dropdown'">
              <a href="#" class="nav-link" @click.prevent>
                {{ item.name }}<span class="dropdown-arrow">▼</span>
              </a>
              <div class="dropdown-content">
                <ul>
                  <li 
                    v-for="(child, childIndex) in item.children" 
                    :key="childIndex"
                    class="dropdown-submenu"
                  >
                    <!-- Child Link -->
                    <router-link 
                      v-if="child.type === 'link'" 
                      :to="child.path" 
                      @click="closeAllDropdowns"
                      :class="{ 'router-link-active': $route.path === child.path }"
                    >
                      {{ child.name }}
                    </router-link>
                    
                    <!-- Child Dropdown -->
                    <template v-else-if="child.type === 'dropdown'">
                      <a class="mx-2" href="#" @click.prevent>{{ child.name }}</a>
                  <ul class="submenu border-0">
                        <li 
                          v-for="(grandChild, grandChildIndex) in child.children" 
                          :key="grandChildIndex"
                          class="dropdown-submenu border-0"
                        >
                          <!-- Grand Child Link -->
                          <router-link 
                            v-if="grandChild.type === 'link'" 
                            :to="grandChild.path" 
                            @click="closeAllDropdowns"
                            :class="{ 'router-link-active': $route.path === grandChild.path }"
                          >
                            {{ grandChild.name }}
                          </router-link>
                          
                          <!-- Grand Child Dropdown -->
                          <template v-else-if="grandChild.type === 'dropdown'">
                            <a href="#" @click.prevent>
                              {{ grandChild.name }} 
                              <span class="dropdown-btn">
                                <span class="icon-07"></span>
                              </span>
                            </a>
                      <ul class="submenu">
                              <li 
                                v-for="(greatGrandChild, greatGrandChildIndex) in grandChild.children" 
                                :key="greatGrandChildIndex"
                              >
                                <router-link 
                                  :to="greatGrandChild.path" 
                                  @click="closeAllDropdowns"
                                  :class="{ 'router-link-active': $route.path === greatGrandChild.path }"
                                >
                                  {{ greatGrandChild.name }}
                                </router-link>
                              </li>
                      </ul>
                          </template>
                    </li>
                  </ul>
                    </template>
                </li>
              </ul>
            </div>
            </template>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      isMenuOpen: false,
      isMobile: false,
      openDropdown: null,
      navigationItems: [
        {
          name: 'Synergy',
          path: '/synergy',
          type: 'link'
        },
        {
          name: 'Technology',
          path: '/sogdotech',
          type: 'link'
        },
        {
          name: 'AI & ML',
          path: '/ai-ml',
          type: 'link'
        },
        {
          name: 'Research',
          path: '/research',
          type: 'link'
        },
        {
          name: 'Services',
          path: '#',
          type: 'dropdown',
          children: [
            {
              name: 'Home',
              path: '#',
              type: 'dropdown',
              children: [
                {
                  name: 'ChampaVehicle',
                  path: '#',
                  type: 'dropdown',
                  children: [
                    {
                      name: 'Normal Car Services',
                      path: '/services/normal-car',
                      type: 'link'
                    },
                    {
                      name: 'Electric Car Services',
                      path: '/services/electric-car',
                      type: 'link'
                    },
                    {
                      name: 'Normal Bike Services',
                      path: '/services/normal-bike',
                      type: 'link'
                    },
                    {
                      name: 'Electric Bike Services',
                      path: '/services/electric-bike',
                      type: 'link'
                    },
                    {
                      name: 'Auto Services',
                      path: '/services/auto',
                      type: 'link'
                    },
                    {
                      name: 'Champaran Elite Touch',
                      path: '/services/champaran-elite',
                      type: 'link'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          name: 'Why Sogdo',
          path: '/why-sogdo',
          type: 'link'
        }
      ]
    }
  },
  computed: {
    isChapaVehicleActive() {
      const chapaVehiclePaths = [
        '/services/normal-car',
        '/services/electric-car',
        '/services/normal-bike',
        '/services/electric-bike',
        '/services/auto',
        '/services/champaran-elite'
      ];
      return chapaVehiclePaths.includes(this.$route.path);
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
      this.openDropdown = null
    },
    toggleDropdown(dropdown) {
      console.log('Toggle dropdown clicked:', dropdown, 'Current:', this.openDropdown)
      if (this.openDropdown === dropdown) {
        this.openDropdown = null
        console.log('Closing dropdown:', dropdown)
      } else {
        this.openDropdown = dropdown
        console.log('Opening dropdown:', dropdown)
      }
      console.log('New dropdown state:', this.openDropdown)
      console.log('DOM elements with show class:', document.querySelectorAll('.mobile-menu .dropdown-menu.show'))
      // Force reactivity update
      this.$forceUpdate()
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 991
      if (!this.isMobile) {
        this.isMenuOpen = false
        this.openDropdown = null
      }
    },
    refreshIfActive(path) {
      if (this.$route.path === path) {
        window.location.reload();
      }
    },
    closeDropdown() {
      // Close any open dropdowns when a menu item is clicked
      this.openDropdown = null;
      // Also close mobile menu if it's open
      this.isMenuOpen = false;
    },
    closeAllDropdowns() {
      // Close all dropdowns and mobile menu
      this.openDropdown = null;
      this.isMenuOpen = false;
      // Force close desktop dropdowns by adding a temporary class
      document.body.classList.add('force-close-dropdowns');
      setTimeout(() => {
        document.body.classList.remove('force-close-dropdowns');
      }, 100);
    },
  },
  watch: {
    '$route'() {
      // Close all dropdowns when route changes
      this.closeAllDropdowns();
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  }
};
</script>

<style scoped>
.header {
  background: linear-gradient(to right, #000000, #0B2B3C);
  color: var(--text-light);
  padding: 1rem 40px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.header-container {
  display: flex;
  justify-content: space-between; /* Distribute space between logo, nav, and spacer */
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}


.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-text {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.logo::after,
.logo:hover::after,
.router-link-exact-active.logo::after,
.router-link-active.logo::after {
  display: none;
}

.router-link-exact-active .logo-text,
.router-link-active .logo-text {
  color: var(--secondary-color);
}

.main-nav {
  display: flex;
  align-items: center;
  justify-content: center; /* Center the nav items */
  margin-left: auto;
}

.nav-links {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem; /* Increased gap between items */
}

.nav-item {
  margin: 0;
}

.nav-link {
  color: var(--text-light);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: var(--secondary-color);
}

.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -5px;
  left: 0;
  background: var(--sogdo-gradient);
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.nav-link.router-link-active {
  color: var(--secondary-color);
}

.nav-link.router-link-active::after {
  width: 100%;
}


/* Mobile Navigation Styles */
.mobile-nav-toggler {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 8px;
  background: none;
  border: none;
  z-index: 10001;
}

.desktop-nav {
  display: flex;
}

.mobile-nav-toggler .icon-bar {
  width: 25px;
  height: 3px;
  background-color: #ffffff;
  margin: 3px 0;
  transition: 0.3s;
  display: block;
}

.mobile-nav-toggler.active .icon-bar:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-nav-toggler.active .icon-bar:nth-child(2) {
  opacity: 0;
}

.mobile-nav-toggler.active .icon-bar:nth-child(3) {
  transform:rotate(-45deg) translate(8px, -8px);
}


.menu-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  z-index: 10000;
}


.nav-logo {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 0px;
}
.nav-logo a{
  text-decoration: none;
}

.nav-logo .logo-text {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: bold;
  text-decoration: none;
}

.menu-outer {
  margin-bottom: 30px;
}

.navigation {
  list-style: none;
  padding: 0;
  margin: 0;
}

.navigation .nav-item {
  margin: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.navigation .nav-item a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 15px 0;
  font-size: 16px;
  transition: color 0.3s ease;
}

.navigation .nav-item a:hover {
  color: var(--secondary-color);
}

/* Mobile Menu Custom Styles */
.mobile-menu .navigation {
  display: flex;
  flex-direction: column;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu .navigation .nav-item {
  width: 100%;
  margin: 0;
  position: relative;
}

.mobile-menu .navigation .nav-item:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-menu .navigation .nav-item a {
  width: 100%;
  display: block;
  padding: 15px 20px;
  text-align: left;
  font-size: 16px;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
}

.mobile-menu .navigation .nav-item a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--secondary-color);
}

/* Dropdown Styles */
.mobile-menu .navigation .nav-item.dropdown {
  position: relative;
}

.mobile-menu .navigation .nav-item.dropdown a {
  padding-right: 50px;
}

.mobile-menu .dropdown-btn {
  position: absolute;
  right: 20px;
  top: 10px!important;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  z-index: 10;
  
}

.mobile-menu .dropdown-btn.open {
  transform: rotate(90deg)!important;
}

.mobile-menu .dropdown-btn.open span {
  transform: rotate(0deg);
}

.mobile-menu .dropdown-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.mobile-menu .dropdown-btn span {
  color: #ffffff;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transform-origin: center;
}

.mobile-menu .dropdown-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #00061a;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 5;
  display: none;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  border-radius: 0;
  width: 100%;
  left: 0;
}

.mobile-menu .dropdown-menu.show {
  display: block;
  max-height: 500px;
}

.mobile-menu .dropdown-menu li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

.mobile-menu .dropdown-menu li:last-child {
  border-bottom: none;
}

.mobile-menu .dropdown-menu a {
  padding: 12px 20px 12px 20px;
  font-size: 14px;
  color: #cccccc;
  display: block;
  width: 100%;
  margin: 0;
  text-decoration: none;
}

.mobile-menu .dropdown-menu a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* Mobile multi-level dropdown styles */
.mobile-menu .dropdown-submenu {
  position: relative;
  display: flex;
}

.mobile-menu .dropdown-submenu > a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;
}

.mobile-menu .dropdown-submenu .dropdown-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  color: #ffffff;
  font-size: 12px;
}

.mobile-menu .dropdown-submenu .dropdown-btn .icon-07 {
  font-size: 12px;
  color: #ffffff;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.mobile-menu .dropdown-submenu .dropdown-menu.show ~ a .dropdown-btn {
  transform: translateY(-50%) rotate(90deg);
}

/* Arrow rotation for nested dropdowns */
.mobile-menu .nested-dropdown.show ~ a .dropdown-btn .icon-07 {
  transform: rotate(90deg);
}

.mobile-menu .nested-dropdown.level-2.show ~ a .dropdown-btn .icon-07 {
  transform: rotate(90deg);
}

/* First level nested dropdown */
.mobile-menu .nested-dropdown {
  background-color: #00061a;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-left: 20px;
  border-radius: 0;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  list-style: none;
  padding: 0;
}

.mobile-menu .dropdown-menu.show .nested-dropdown {
  max-height: 500px;
}

/* Second level nested dropdown */
.mobile-menu .nested-dropdown.level-2 {
  background-color: #00061a;
  margin-left: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-menu .nested-dropdown.level-2.show {
  max-height: 500px;
}

/* Nested dropdown items */
.mobile-menu .nested-dropdown li {
  width: 100%;
  display: block;
}

.mobile-menu .nested-dropdown li a {
  display: block;
  padding: 12px 20px;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.mobile-menu .nested-dropdown li a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #007bff;
}

.mobile-menu .dropdown-submenu .dropdown-menu li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.mobile-menu .dropdown-submenu .dropdown-menu a {
  padding: 10px 20px 10px 20px;
  font-size: 13px;
  color: #bbbbbb;
}


.contact-info h4 {
  color: #ffffff;
  margin-bottom: 15px;
  font-size: 18px;
}

.contact-info ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info li {
  color: #cccccc;
  margin-bottom: 8px;
  font-size: 14px;
}

.contact-info a {
  color: var(--secondary-color);
  text-decoration: none;
}

/* Mobile styles */
@media (max-width: 991px) {
  .main-nav {
    position: relative;
  }

  .dropdown-content {
    display: none;
  }
}

/* Add gradient border effect */
.header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--sogdo-gradient);
}

.main-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 50px;
}

/* Mobile specific gap override */
@media (max-width: 991px) {
  .main-nav ul {
    gap: 0;
  }
}

.dropdown {
  position: relative;
}

.dropdown-arrow {
  font-size: 10px;
  margin-left: 6px;
  transition: transform 0.2s ease;
  display: inline-block;
  color: var(--text-light);
  font-weight: bold;
  vertical-align: middle;
}

.dropdown:hover .dropdown-arrow,
.dropdown.dropdown-open .dropdown-arrow {
  transform: rotate(180deg);
}

/* Ensure main dropdown arrow shows on hover */
.dropdown.nav-item:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-content {
  display: none;
  position: absolute;
  top: calc(100% - 2px);
  left: 50%;
  transform: translateX(-50%);
  background: #00061A;
  border: 1px solid rgba(246, 236, 79, 0.3);
  border-radius: 8px;
  min-width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  padding: 8px 0;
  margin-top: 0;
}

/* Show dropdown on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Keep dropdown open when hovering over the content */
.dropdown-content:hover {
  display: block;
}

/* Nested dropdown hover behavior */
.dropdown-submenu:hover .submenu {
  display: block;
}

.submenu:hover {
  display: block;
}

/* Force close dropdowns when navigating */
.force-close-dropdowns .dropdown-content,
.force-close-dropdowns .submenu {
  display: none !important;
}

.dropdown-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-content li {
  margin: 0;
}

.dropdown-content li a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 10px 16px;
  transition: all 0.2s ease;
  font-size: 14px;
}

.dropdown-content li a:hover {
  background: rgba(246, 236, 79, 0.1);
  color: #F6EC4F;
}

/* Multi-level dropdown styles */
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

/* Only add padding-right for items with arrows */
.dropdown-submenu > a:has(.dropdown-btn) {
  padding-right: 100px;
}

.submenu-arrow {
  font-size: 10px;
  transition: transform 0.2s ease;
  color: #ccc;
}

/* Show arrow rotation on hover */
.dropdown-submenu:hover .submenu-arrow {
  transform: rotate(90deg);
}

/* Desktop dropdown icon styling */
.dropdown-submenu .dropdown-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.dropdown-submenu:hover .dropdown-btn {
  transform: translateY(-50%) rotate(90deg);
}

.dropdown-submenu .dropdown-btn .icon-07 {
  color: #ccc;
  font-size: 12px;
}

.submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  background: #00061A;
  border: 1px solid rgba(246, 236, 79, 0.3);
  border-radius: 8px;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  z-index: 1001;
  padding: 8px 0;
  margin-left: 2px;
}

.submenu ul {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Show only immediate child submenu on hover */
.dropdown-submenu:hover > .submenu {
  display: block;
}

/* Hide nested submenus by default */
.dropdown-submenu .submenu .submenu {
  display: none;
}

/* Show nested submenu only when hovering over its parent */
.dropdown-submenu .submenu .dropdown-submenu:hover > .submenu {
  display: block;
}

.submenu li {
  margin: 0;
  margin-bottom: 8px;
}

.submenu li:last-child {
  margin-bottom: 0;
}

.submenu li a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 10px 16px;
  transition: all 0.2s ease;
  font-size: 14px;
}

.submenu li a:hover {
  background: rgba(246, 236, 79, 0.1);
  color: #F6EC4F;
}

/* Nested submenu positioning */
.submenu .submenu {
  left: 50%;
  top: 30px;
  margin-left: 2px;
}

.active-logo-text {
  font-weight: 900;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
}

.nav-right-spacer {
  width: 40px; /* Same width as the logo's left margin */
}

/* Active state for ChapaVehicle items */
.router-link-active {
  color: var(--secondary-color) !important;
  font-weight: 600;
}

/* Mobile active state */
.mobile-menu .router-link-active {
  background-color: rgba(246, 236, 79, 0.1);
  color: #F6EC4F !important;
}

/* Desktop active state */
.desktop-nav .router-link-active {
  color: var(--secondary-color) !important;
}

/* Nested dropdown active state */
.nested-dropdown .router-link-active,
.submenu .router-link-active {
  background-color: rgba(246, 236, 79, 0.1);
  color: #F6EC4F !important;
  font-weight: 600;
}

/* Remove parent active state - only highlight the specific active item */
</style>